// SPDX-FileCopyrightText: 2024 - 2025 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2024 - 2025 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

export default function HomepageDivider() {
  return (
    <div className="w-full max-w-(--breakpoint-xl) mx-auto border-t border-[#90909060] mt-[80px]"></div>
  )
}
